export default __webpack_public_path__ + "static/media/3.a3ebc3e0.png";